export default __webpack_public_path__ + "static/media/MobileView.9bdba8fd.svg";